<div class="modal-header">
    <h4 class="modal-title">{{ 'MODAL_IMPORT_EXHIBITOR.TITLE' | translate }}</h4>
    <img class="pointer" width="24" height="24" alt="close" src="assets/img/close.svg" (click)="close()">
</div>
<div class="modal-body">
    <div *ngFor="let item of importData; let i = index; last as lastCatalogue">
        <ng-container>
            <div class="d-flex align-items-center" (click)="toggleExhibitors(i);toggleDisplay(item)">
                <span *ngIf="!item.isDisplayed" style="margin-bottom:12px">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right" viewBox="0 0 16 16">
                        <path d="M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753"/>
                    </svg>
                </span>
                <span *ngIf="item.isDisplayed" style="margin-bottom:12px">     
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down" viewBox="0 0 16 16">
                        <path d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659"/>
                    </svg>
                </span>
                <h3 class="bold">{{ item.label }}</h3>
            </div>
        </ng-container>
        <ng-container *ngIf="openIndex === i">
            <div *ngFor="let exhibitor of item.exhibitors" class="data-row">           
                <div class="other_data pointer">
                    <div class="exhibitor_manipulation">
                        <ng-container>
                            <span *ngIf="!exhibitor.isDisplayed" (click)="toggleDisplay(exhibitor)">     
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-right" viewBox="0 0 16 16">
                                    <path d="M6 12.796V3.204L11.481 8zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753"/>
                                </svg>
                            </span>
                            <span *ngIf="exhibitor.isDisplayed" (click)="toggleDisplay(exhibitor)">     
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-caret-down" viewBox="0 0 16 16">
                                    <path d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659"/>
                                </svg>
                            </span>
                        </ng-container>
                        <span class="data_check valign-middle">
                        <input type="checkbox" [(ngModel)]="exhibitor.isSelected" [disabled]="copyData.exhibitorId && copyData.exhibitorId !== exhibitor.id"
                                name="exhibitor_sel_{{exhibitor.id}}" (change)="onExhibitorChangeCheck(exhibitor, $event)">
                        </span>
                    </div>
                    <div class="exhibitor_data">
                        <i onclick="myFunction(this)" class="fa fa-fw fa-caret-right"></i>
                        <div class="image_data">
                          <div class="image">
                            <div class="image-wrap">
                              <img class="theImage" [src]="getImage(exhibitor)" alt="Image">
                            </div>
                          </div>
                        </div>
                        <div class="other_data pointer" (click)="toggleDisplay(exhibitor)">
                          <span class="exhibitor pointer valign-middle">{{exhibitor.name}}</span>
                          <div class="data">
                            <div *ngIf="exhibitor.standLocation">
                              <div>
                                <span class="data_icon"><img src="assets/icons/web_grey.svg"></span>
                                <span class="text">
                                    <app-stand-display [standData]="exhibitor?.standLocation"></app-stand-display>
                                </span>
                              </div>
                              <div>
                                <span class="data_icon"><img src="assets/icons/maps.svg"></span>
                                <span class="text" *ngIf="exhibitor.addressLine1">{{exhibitor.addressLine1}},</span>
                                <span class="text" *ngIf="exhibitor.city">{{exhibitor.city}},</span>
                                <span class="text" *ngIf="exhibitor.zipCode">{{exhibitor.zipCode}},</span>
                                <span class="text" *ngIf="exhibitor.country">
                                    {{_api(exhibitor.country.countryTranslations, 'description')}}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                    </div>
                    <ng-container *ngIf="exhibitor.products && exhibitor.isDisplayed">
                        <hr/>
                        <div class="product" *ngFor="let product of exhibitor.products; last as isLast">
                            <div class="exhibitor_manipulation">
                            <span class="data_check">
                                <input type="checkbox" [(ngModel)]="product.isSelected" name="product_sel_{{product.id}}" (change)="onProductChangeCheck(product, $event)">
                            </span>
                            </div>
                            <div class="exhibitor_data pointer" (click)="onProductChange(product, !product.isSelected, true)">
                            <div class="image_data">
                                <div class="image">
                                <div class="image-wrap">
                                    <img class="theImage" [src]="getProductImage(product)" alt="Image">
                                </div>
                                </div>
                            </div>
                            <div class="other_data">
                                <span class="exhibitor pointer valign-middle">{{_api(product.translations, 'name')}}</span>
                                <div class="data">{{_api(product.translations, 'description')}}</div>
                            </div>
                            </div>
                            <hr *ngIf="!isLast">
                        </div>
                    </ng-container>
                </div>
            </div>
        </ng-container>
        <hr *ngIf="!lastCatalogue">
    </div>
</div>
<div class="modal-footer">
    <button type="button" (click)="close()" class="btn btn-light mx-sm-2" >{{ 'COMMON.CANCEL' | translate }}</button>  
    <button type="button" (click)="setOption('yes')" class="btn btn--submit mx-sm-2" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">{{ 'COMMON.YES' | translate }}</button>
</div>